import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.slice";
import _reduce from "lodash/reduce";
import _size from "lodash/size";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getLogger } from '@nerdwallet/logging';
var logger = getLogger('jat-string-utils');
export var toSentenceCase = function toSentenceCase(str) {
  if (!str || _size(str) === 0) {
    return '';
  }

  var lowerCaseStr = str.toLowerCase();
  var upperCaseFirstLetter = lowerCaseStr.charAt(0).toUpperCase();
  return upperCaseFirstLetter + lowerCaseStr.slice(1);
};
export var toTitleCase = function toTitleCase(str) {
  if (!str || _size(str) === 0) {
    return '';
  }

  var strArr = str.split(' ');

  var titleCasedStr = _reduce(strArr, function (acc, word) {
    return "".concat(acc, " ").concat(toSentenceCase(word));
  }, '');

  return titleCasedStr.trim();
};
/**
 * Cache for Intl.NumberFormat formatters. Use {@link:createMoneyFormatterHashKey} to get the key
 */

export var formatters = {};
/**
 * Creates a composite cache key for `formatMoney`.
 * @param locale {string} - locale to use. Defaults to `en-US`
 * @param options {Object} - other options, for advanced formatting
 * @returns {string} - cache key for the formatter
 */

export var createMoneyFormatterHashKey = function createMoneyFormatterHashKey(locale) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return "".concat(locale, "_").concat(JSON.stringify(options));
};
/**
 * Formats a monetary value. Is a light wrapper around Intl.NumberFormat
 * @param amount {number} - monetary amount to format (in dollars or currency equivalent)
 * @param includeCents {boolean} - Whether to include cents or not
 * @param currency {string} - 3-letter currency code. Defaults to `USD`
 * @param locale {string} - locale to use. Defaults to `en-US`
 * @param options {Object} - misc other options to pass to NumberFormat. Will override previous settings.
 * @returns {string} - formatted monetary amount
 */

export var formatMoney = function formatMoney(amount) {
  var includeCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
  var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'en-US';
  var options = arguments.length > 4 ? arguments[4] : undefined;
  // Do not allow arbitrary locales to prevent potential memory leak
  var validatedLocale;

  try {
    // @ts-ignore TS2339 -- TS doesn't recognize `getCanonicalLocales` for some reason even though it's legit
    validatedLocale = Intl.getCanonicalLocales(locale);
  } catch (e) {
    logger.warn("Money formatter received invalid locale ".concat(locale, " -- falling back to 'en-US'"));
    validatedLocale = 'en-US';
  }

  var formatterOptions = _objectSpread({
    style: 'currency',
    currency: currency,
    maximumFractionDigits: includeCents ? 2 : 0,
    minimumFractionDigits: includeCents ? 2 : 0
  }, options);

  var key = createMoneyFormatterHashKey(locale, formatterOptions);
  var formatter = formatters[key];

  if (!formatter) {
    formatter = new Intl.NumberFormat(validatedLocale, formatterOptions);
    formatters[key] = formatter;
  } // explicitly fall back to 0, otherwise a `-0` value might be displayed


  return formatter.format(amount || 0);
};